<template>
    <CModal
        :title="title"
        :show.sync="modalTambah"
        :no-close-on-backdrop="true"
        :centered="true"
    >
        <template #header>
            <h6 class="modal-title h5 font-weight-bold">Tambah Penerima</h6>
        </template>
        <CRow>
            <CCol sm="12" class="mb-2">              
                <label for="nama" class="font-weight-bold">Tipe Penerima</label>
                <select name="" class="form-control" id="" v-model="formData.tipePenerima">
                    <option value="iapi">IAPI</option>
                    <option value="nonIapi">NON IAPI</option>
                </select>
            </CCol>
            <CCol sm="12" class="mb-2" v-if="formData.tipePenerima == 'iapi'">
                <label for="nama" class="font-weight-bold">Anggota</label>
                <multiselect
                    class="mulit-select"
                    label="nama_lengkap"
                    placeholder="Pilih Anggota"
                    :show-labels="false"
                    @select="pilihAnggota"
                    v-model="dataAnggotaModel"
                    id="anggota"
                    :options="optionDataAnggota"
                ></multiselect>                                                
            </CCol>
            <div class="col-md-12" v-if="formData.tipePenerima == 'nonIapi'">
                <div class="mb-2">
                    <label for="nama" class="font-weight-bold" >Nama Lengkap</label>
                    <input type="text" class="form-control" placeholder="Masukkan nama lengkap" v-model="formData.namaLengkap">
                </div>
                <div class="mb-2">
                    <label for="nama" class="font-weight-bold">No Telepon</label>
                    <input type="number" class="form-control" placeholder="Masukkan no telepon" v-model="formData.noTelepon">
                </div>
                <div class="mb-2">
                    <label for="nama" class="font-weight-bold">Email</label>
                    <input type="email" class="form-control" placeholder="Masukkan email" v-model="formData.email">
                </div>
            </div>
            <div class="col-md-12">
                <div class="mb-2">
                    <label for="nama" class="font-weight-bold">Alasan</label>
                    <textarea class="form-control" cols="30" rows="10" v-model="formData.alasan"></textarea>
                </div>
            </div>
           
        </CRow>
        <template #footer>        
            <CButton @click="modalTambah = false" color="danger">Tutup</CButton>
            <CButton color="info" @click="postDataPenerima">Simpan</CButton>            
        </template>
    </CModal>
</template>

<script>



export default {
      
    name: 'modal-tambah-penerima',
    props: [
        'modalTambah',
        'title',
        'formData',
        'optionDataAnggota',
        'dataAnggotaModel'
    ],

    // mounted() {
    //     this.getAllDataAnggota();
    // },

    watch: {
        modalTambah: function(val) {
            if(!this.modalTambah) {                
                this.$emit('closeModalTambah', val)
            }            
        },        
    },

    methods: {
        pilihAnggota(value) {
            this.formData.idUser = value.id_user;
        },
        postDataPenerima() {
            this.$parent.postDataPenerima(this.formData);
        }
    },

    computed: {
      
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
